import React from 'react';

const SchoolsListItemPlaceholder = () => (
    <div className="col col-12 col-lg-4">
        <div className="item placeholder">
            <div className="thumbnail">
                <span className="placeholder"></span>
            </div>
            <span className="title">
                <span className="placeholder"></span>
            </span>
            <div className="address">
                <span className="city">
                    <span className="placeholder"></span>
                </span>
                <span className="street">
                    <span className="placeholder"></span>
                </span>
            </div>
        </div>
    </div>
);

export default SchoolsListItemPlaceholder;


// WEBPACK FOOTER //
// ./src/features/Schools/components/List/SchoolsListItemPlaceholder.js